import { Box, Image, Rating, Text, Title } from "@mantine/core";
import { ReactNode } from "react";
import { BsFillPuzzleFill, BsPuzzle } from "react-icons/bs";

import styles from "./card.module.css";

interface CardProps {
    image?: string | string[];
    icon?: React.ReactNode;
    difficulty?: number;
    title: string;
    description: ReactNode;
    highlights?: string[];
    children?: React.ReactNode;
    layout?: "vertical" | "horizontal";
    imageBadge?: React.ReactNode;
    className?: string;
}

export const Card = ({ className, ...restProps }: CardProps) => {
    return <CardContent {...restProps} className={`${styles.animationCard} ${className || ""}`} />;
};
export const CardContent = ({
    children,
    icon,
    difficulty,
    image,
    title,
    description,
    highlights,
    layout = "vertical",
    imageBadge,
    className,
}: CardProps) => {
    const images = Array.isArray(image) ? image : image ? [image] : [];
    return (
        <Box className={`${styles.card} ${styles.landingPageCards} ${className} ${layout === "horizontal" ? styles.horizontal : ""}`}>
            {images.length > 0 && (
                <div className={styles.imageContainer}>
                    {images.map((img) => (
                        <Image src={img} radius="lg" key={img} alt={title} />
                    ))}

                    {imageBadge}
                </div>
            )}

            <div className={styles.contentContainer}>
                {icon && <div className={styles.iconWrapper}>{icon}</div>}

                {difficulty && (
                    <Rating
                        mt="md"
                        className={styles.difficulty}
                        value={difficulty}
                        readOnly
                        emptySymbol={<BsPuzzle color="var(--mantine-color-gray-6)" size={16} />}
                        fullSymbol={<BsFillPuzzleFill color="var(--mantine-color-gray-6)" size={24} />}
                    />
                )}

                <Title order={3} className="title" mt="md">
                    {title}
                </Title>

                {description && (
                    <Text className="description" mt="md" mb="md" c="var(--mantine-color-gray-6)">
                        {description}
                    </Text>
                )}

                {highlights && Array.isArray(highlights) && highlights.length > 0 && (
                    <ul>
                        {highlights.map((highlight) => (
                            <li key={highlight}>
                                <span />
                                {highlight}
                            </li>
                        ))}
                    </ul>
                )}

                {children}
            </div>
        </Box>
    );
};
